import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';
import { SEARCH_MODE } from '../../utils/program-review.utils';

const SearchModeToggle = ({ mode, onChange }) => (
  <Box display="flex" gap={1} alignItems="center" data-testid="lms-course-review-search-mode">
    <Chip
      label="Search by Course"
      color={mode === SEARCH_MODE.COURSE ? 'primary' : 'default'}
      variant={mode === SEARCH_MODE.COURSE ? 'filled' : 'outlined'}
      onClick={() => onChange(SEARCH_MODE.COURSE)}
      clickable
      data-testid="search-mode-course"
    />
    <Chip
      label="Search by Program"
      color={mode === SEARCH_MODE.PROGRAM ? 'primary' : 'default'}
      variant={mode === SEARCH_MODE.PROGRAM ? 'filled' : 'outlined'}
      onClick={() => onChange(SEARCH_MODE.PROGRAM)}
      clickable
      data-testid="search-mode-program"
    />
  </Box>
);

SearchModeToggle.propTypes = {
  mode: PropTypes.oneOf(Object.values(SEARCH_MODE)).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SearchModeToggle;
